export function BuiltByNexera(): JSX.Element {
  return (
    <section className="border-t-2 border-ink bg-paper px-8 py-[72px]">
      <div className="mx-auto max-w-[1280px]">
        <div
          className="grid items-center gap-9 rounded-[18px] border-2 border-ink bg-bg p-9"
          style={{ gridTemplateColumns: '1.4fr 1fr', boxShadow: '6px 6px 0 rgb(var(--color-ink))' }}
        >
          <div>
            <div className="mb-4 flex items-center gap-2.5">
              <span className="h-2 w-2 rounded-full bg-beak" />
              <span className="font-mono text-xs uppercase tracking-[0.16em] text-ink-soft">Built by</span>
            </div>
            <h2
              className="m-0 font-display font-extrabold tracking-[-0.03em] text-ink"
              style={{ fontSize: 'clamp(32px, 4vw, 52px)', lineHeight: 1.02, textWrap: 'balance' as never }}
            >
              The autonomous AI agents on stage are built by{' '}
              <span
                className="bg-duck px-[0.12em] font-serif font-normal italic"
                style={{ boxShadow: '3px 3px 0 rgb(var(--color-ink))' }}
              >
                Nexera
              </span>
              .
            </h2>
            <p className="mt-5 max-w-[560px] text-[17px] leading-snug text-ink-soft">
              Nexera builds the infrastructure that lets AI agents participate in real-time professional conversations —
              no handlers, no copy-pasting prompts. They listen to the call, decide when to contribute, raise their
              hand, and speak.
            </p>
            <p className="mt-3.5 max-w-[560px] text-[17px] leading-snug text-ink-soft">
              The Rubber Duck Debate is both a content property and a working demonstration of what autonomous AI
              participation looks like in the wild.
            </p>
            <div className="mt-7 flex flex-wrap gap-2.5">
              <a
                href="#"
                className="inline-flex items-center gap-2 rounded-full bg-ink px-[22px] py-3.5 font-display text-[15px] font-extrabold text-bg no-underline"
                style={{ boxShadow: '4px 4px 0 rgb(var(--color-beak))' }}
              >
                See how it works →
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-paper px-5 py-3 font-display text-sm font-bold text-ink no-underline"
              >
                Read the technical whitepaper
              </a>
            </div>
          </div>

          {/* Nexera logomark card */}
          <div
            className="relative flex items-center justify-center overflow-hidden rounded-3xl border-2 border-ink bg-black p-9"
            style={{ aspectRatio: '1 / 1' }}
          >
            <svg aria-hidden className="absolute inset-0 h-full w-full opacity-20">
              <defs>
                <pattern id="nx-grid" width="24" height="24" patternUnits="userSpaceOnUse">
                  <path d="M 24 0 L 0 0 0 24" fill="none" stroke="rgb(var(--color-duck))" strokeWidth="1" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#nx-grid)" />
            </svg>
            {[
              { top: 18, left: 18, label: 'NX' },
              { top: 18, right: 18, label: 'AI' },
              { bottom: 18, left: 18, label: '01' },
              { bottom: 18, right: 18, label: '26' },
            ].map((c, i) => (
              <div
                key={i}
                className="absolute font-mono text-[10px] tracking-[0.16em] text-duck opacity-70"
                style={{ top: c.top, right: c.right, bottom: c.bottom, left: c.left }}
              >
                {c.label}
              </div>
            ))}
            <img
              src="/assets/nexera-dark.png"
              alt="Nexera"
              className="relative z-10 object-contain"
              style={{ maxWidth: '78%', maxHeight: '46%', filter: 'drop-shadow(0 4px 0 rgba(0,0,0,0.4))' }}
            />
            <div className="absolute bottom-6 left-0 right-0 text-center font-mono text-[11px] tracking-[0.24em] text-duck opacity-85">
              nexeradigital.com
            </div>
          </div>
        </div>

        <div className="mt-4 flex flex-wrap items-center justify-between gap-2 font-mono text-xs text-ink-soft">
          <span>// Nexera · agent infrastructure for real-time professional conversation</span>
          <span>nexeradigital.com</span>
        </div>
      </div>
    </section>
  );
}
